import React, { Component } from 'react';

class Navbar extends Component {
    render() {
       // <input type="checkbox" id="switch" /><label for="switch">Toggle</label>
        return (
            <div className='Navbar'>
              
               Welcome To Trading Booth
        
            </div>
            
        );
    }
}

export default Navbar;